var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('w-button',{attrs:{"color":"text","tooltip":_vm.toolTip,"tooltip-position":'bottom',"icon":_vm.logo,"size":_vm.size},on:{"click":function($event){$event.stopPropagation();return _vm.startVideoCommentRecording.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }